"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = windowEvents;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _eventemitter = _interopRequireDefault(require("eventemitter3"));

var _react = _interopRequireWildcard(require("react"));

var _getDisplayName = _interopRequireDefault(require("../utils/get-display-name"));

var _raf = require("../utils/raf");

function _createSuper(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

var events = new _eventemitter.default();
var handlers;

function createHandlers() {
  return {
    scroll: {
      handler: (0, _raf.throttle)(function (e) {
        events.emit('scroll', e);
      }),
      capture: true
    },
    resize: {
      handler: (0, _raf.throttle)(function (e) {
        events.emit('resize', e);
      })
    },
    click: {
      handler: function handler(e) {
        events.emit('click', e);
      },
      capture: true
    },
    mousedown: {
      handler: function handler(e) {
        events.emit('mousedown', e);
      },
      capture: true
    },
    touchstart: {
      handler: function handler(e) {
        events.emit('touchstart', e);
      },
      capture: true
    }
  };
}

function windowEvents() {
  for (var _len = arguments.length, types = new Array(_len), _key = 0; _key < _len; _key++) {
    types[_key] = arguments[_key];
  }

  return function (OriginalComponent) {
    var _class, _temp;

    return _temp = _class = /*#__PURE__*/function (_Component) {
      (0, _inherits2.default)(WrappedComponent, _Component);

      var _super = _createSuper(WrappedComponent);

      function WrappedComponent() {
        (0, _classCallCheck2.default)(this, WrappedComponent);
        return _super.apply(this, arguments);
      }

      (0, _createClass2.default)(WrappedComponent, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          handlers = handlers || createHandlers();
          types.forEach(function (type) {
            if (!handlers[type].listenersCount) {
              handlers[type].listenersCount = 0;
              window.addEventListener(type, handlers[type].handler, handlers[type].capture);
            }

            handlers[type].listenersCount++;
          });
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          types.forEach(function (type) {
            handlers[type].listenersCount--;
            if (!handlers[type].listenersCount) window.removeEventListener(type, handlers[type].handler, handlers[type].capture);
          });
        }
      }, {
        key: "render",
        value: function render() {
          return _react.default.createElement(OriginalComponent, (0, _extends2.default)({}, this.props, {
            windowEvents: events
          }));
        }
      }]);
      return WrappedComponent;
    }(_react.Component), _class.displayName = "windowEvents(".concat((0, _getDisplayName.default)(OriginalComponent), ")"), _temp;
  };
}